import type { StateCreator } from 'zustand';

import { ODYSSEY_CONFIG } from '@/modules/promotions/components/HeadlinePromo/Odyssey/config';
import { OKTOBERFEST_CONFIG } from '@/modules/promotions/components/HeadlinePromo/Oktoberfest/config';
import { SOLAR_PASS_CONFIG } from '@/modules/promotions/components/HeadlinePromo/SolarPass/config';
import type {
  CommonStoreType,
  HeadlinePromoState,
} from '@/store/commonStore/types';

export const useHeadlinePromoSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  HeadlinePromoState
> = () => ({
  headlinePromoConfigs: [OKTOBERFEST_CONFIG, SOLAR_PASS_CONFIG, ODYSSEY_CONFIG],
});
